export const actions = {
    GET_UNREAD_MESSAGE_COUNT: 'GET_UNREAD_MESSAGE_COUNT',
    SET_UNREAD_MESSAGE_COUNT: 'SET_UNREAD_MESSAGE_COUNT',
    GET_MESSAGE_LIST: 'GET_MESSAGE_LIST',
    SET_MESSAGE_LIST: 'SET_MESSAGE_LIST',
    GET_LOAD_MORE_MESSAGES: 'GET_LOAD_MORE_MESSAGES',
    SET_LOAD_MORE_MESSAGES: 'SET_LOAD_MORE_MESSAGES',
    GET_CONTACTS: 'GET_CONTACTS',
    SET_CONTACTS: 'SET_CONTACTS',
    GET_GROUPS: 'GET_GROUPS',
    SET_GROUPS: 'SET_GROUPS',
    SEND_MESSAGE: 'SEND_MESSAGE',
    SET_SENT_MESSAGE: 'SET_SENT_MESSAGE',
    GET_CONVERSATION_LIST: 'GET_CONVERSATION_LIST',
    SET_CONVERSATION_LIST: 'SET_CONVERSATION_LIST',
    GET_HOME_BOX: 'GET_HOME_BOX',
    SET_HOME_BOX: 'SET_HOME_BOX,',
    SET_DEFAULT_MESSAGE_LIST: 'SET_DEFAULT_MESSAGE_LIST',
    GET_DELETE_MESSAGES: 'GET_DELETE_MESSAGES',
    SET_DEFAULT_CHATPANEL_MESSAGE: 'SET_DEFAULT_CHATPANEL_MESSAGE',
    GET_HEADER_MESSAGE_LIST: 'GET_HEADER_MESSAGE_LIST',
    SET_HEADER_MESSAGE_LIST: 'SET_HEADER_MESSAGE_LIST',
    GET_READ_MESSAGES: 'GET_READ_MESSAGES',
    SET_ORIGIN_MESSAGE_ID: 'SET_ORIGIN_MESSAGE_ID',

};
